import { useContext } from 'react';
import type { FeatureFlag } from '@/enums/feature-flag';
import { FeatureFlagContext } from '@/providers/feature-flag-context';

/**
 * Check if a feature flag is enabled.
 *
 * @param flag - The feature flag to check
 * @returns boolean indicating if the flag is enabled
 *
 * @example
 * const isEnabled = useFeatureFlag(FeatureFlag.SPLIT_SAML_DEMO_PARTIAL_SIGNATURE);
 *
 * @example
 * // Conditional rendering
 * {useFeatureFlag(FeatureFlag.SPLIT_SAML_DEMO_PARTIAL_SIGNATURE) && <Feature />}
 */
export function useFeatureFlag(flag: FeatureFlag): boolean {
  const context = useContext(FeatureFlagContext);

  return context?.isFeatureEnabled(flag) ?? false;
}
